import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import {
  FiltersPresetsRouter,
  FilterPresetsListCode,
} from '../../../filtersPreset/types';

const PAGE_CODES = {
  events: 'events',
  schedule_events: 'vacations',
  absence_events: 'absences',
  employees: 'employees',
  company_policies: 'policy',
  candidate_events: 'candidates',
  goal_management: 'review',
  business_trips: 'business-trips',
};

@injectable()
export class FiltersPresetsRouterService implements FiltersPresetsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToPresetEdit(id: string, listCode: FilterPresetsListCode) {
    this.history.push(
      `/${this.role.get()}/${PAGE_CODES[listCode]}/filters_preset_edit/${id}`,
    );
  }

  goToList(listCode: FilterPresetsListCode) {
    this.history.push(`/${this.role.get()}/${PAGE_CODES[listCode]}`);
  }
}
